var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tag',{staticClass:"TagMatchScore lg",class:_vm.theme},[_vm._v(" "+_vm._s(_vm.$t('score', [_vm.score]))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }